
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import KeywordsSection from "../branding/KeywordsSection";
import BrandVoiceSection from "../branding/BrandVoiceSection";
import ColorsSection from "../branding/ColorsSection";
import SocialMediaSection from "../branding/SocialMediaSection";
import MarketingEffortsSection from "../branding/MarketingEffortsSection";
import BrandGuidelinesTextSection from "../branding/BrandGuidelinesTextSection";
import GuidelinesFileUploader from "../branding/GuidelinesFileUploader";

interface BrandingTabContentProps {
  businessData: any;
  updateBusinessData: (key: string, value: any) => void;
}

const BrandingTabContent: React.FC<BrandingTabContentProps> = ({
  businessData,
  updateBusinessData,
}) => {
  const handleFileUploaded = (fileName: string, filePath: string) => {
    updateBusinessData('guidelineFileName', fileName);
    updateBusinessData('guidelineFilePath', filePath);
  };

  return (
    <div className="space-y-6">
      <KeywordsSection 
        keywords={businessData.keywords || []} 
        updateBusinessData={updateBusinessData}
      />
      
      <BrandVoiceSection 
        brandVoice={businessData.brandVoice} 
        updateBusinessData={updateBusinessData}
      />
      
      <ColorsSection 
        colors={businessData.colors || []} 
        updateBusinessData={updateBusinessData} 
      />
      
      <SocialMediaSection 
        socialMedia={businessData.socialMedia || {}} 
        updateBusinessData={updateBusinessData}
      />
      
      <MarketingEffortsSection 
        marketingEfforts={businessData.marketingEfforts || []} 
        updateBusinessData={updateBusinessData}
      />
      
      <BrandGuidelinesTextSection 
        brandGuidelines={businessData.brandGuidelines || ''} 
        updateBusinessData={updateBusinessData}
      />
      
      <GuidelinesFileUploader 
        businessId={businessData.id} 
        fileName={businessData.guidelineFileName}
        filePath={businessData.guidelineFilePath}
        onFileUploaded={handleFileUploaded}
      />
    </div>
  );
};

export default BrandingTabContent;
